import { Grid, Typography } from "@mui/material";
import MainTitle from "../muiHome/mainTitle";

const SAHSInitiative=()=>{
return (
<Grid container spacing={2}>
<Grid item xs={12}>
    <MainTitle title="School of Pharmaceutical Sciences" />
    </Grid>

     

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        <b>Job Fests and Placement Drives:</b>
        <br/>
        MVN University regularly organizes large-scale Job Fests and campus placement drives, bringing together leading companies across various sectors. These events offer students the opportunity to interact directly with industry recruiters, secure internships and land full-time job placements, thereby bridging the gap between academia and industry.
    </Typography>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
        <b>Faculty Development Programmes (FDPs):</b>
        <br/>
        Focused on academic excellence and research advancement, MVN University conducts Faculty Development Programmes (FDPs) in collaboration with industry leaders and research institutions. These FDPs equip faculty members with the latest teaching methodologies, technological tools and research skills to enhance student learning outcomes.  <br/>  <br/>

        <b> Skill-Building Workshops and Seminars:</b>
        <br/>
        The university regularly hosts workshops and seminars on emerging areas such as Artificial Intelligence, Data Analytics, Pharmaceutical Research, Entrepreneurship, and Soft Skills Development. These events help students stay industry-ready and build critical 21st-century competencies.  <br/>  <br/>


        <b> 	Mentor-Mentee Interaction Programmes:</b>
        <br/> 
MVN University follows a strong Mentor-Mentee system, where each student is paired with a faculty mentor. Regular interactions help address academic concerns, career guidance, personal development and emotional well-being, ensuring that students receive holistic support throughout their academic journey.

        <br/>  <br/>

        <b>	Healthcare and Wellness Camps: </b>
        <br/>
        
Committed to promoting student and staff well-being, MVN University organizes regular Health Check-up Camps, Blood Donation Drives, and Awareness Campaigns on topics like mental health, nutrition and fitness. These initiatives cultivate a healthy and supportive campus environment.

        
        <br/>  <br/>

        <b> 	Entrepreneurship and Innovation Support: </b>
        <br/>
         
Through dedicated Entrepreneurship Cells and Incubation Programs, students are encouraged to develop startups, participate in idea competitions and receive mentorship from successful entrepreneurs and industry experts.

        <br/>  <br/>

        <b> 	Social Responsibility Initiatives: </b>
        <br/>
        
        
MVN University actively involves students and staff in CSR activities like tree plantation drives, cleanliness campaigns and social awareness programs, nurturing socially responsible citizens.

        <br/>  <br/>

        <b>	Personality Development Programmes:  </b>
        <br/>
        MVN University conducts comprehensive Personality Development Programmes and communication skill enhancement programmes to enhance students' communication skills, confidence and leadership qualities.
        
        <br/>  <br/>

       
    </Typography>
    </Grid> 
    </Grid>
    

)
}
export default SAHSInitiative;